import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Pagination from "../../Reusablecomponents/Pagination";
import ExportButton from "../../Reusablecomponents/ExportButton";
import { FaPlus, FaEye, FaFileExport } from "react-icons/fa";
import "../../css/others/Table.css";
import { apiCall } from "../../main/ApiCall";
import { buildUserPayload } from "../../main/buildUserPayload";
import { campaignStatusEnums, FunctionEnum, createToastMessage, ToastMessage } from "../../interFaces/interfaces";
import * as XLSX from 'xlsx-js-style';
import ToastPopup from "../../popups/ToastPopup";
import EncryptionUtils from "../../main/encryptionUtils";
const AuditorFunctionChecklist: React.FC = () => {
  const [data, setData] = useState<any[]>([]);
  const [, setLoading] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [itemsPerPage, setItemsPerPage] = useState<number>(10);
  const [totalElements, setTotalElements] = useState<number>(0);
  const [totalPages, setTotalPages] = useState<number>(0);
  const navigate = useNavigate();
  const [fields, setFields] = useState<any>({});
  const clientId = localStorage.getItem("clientId");
  const [functionEnums, setFunctionEnums] = useState<FunctionEnum[]>([]);
  const [campaignStatusEnums, setCampaignStatusEnums] = useState<campaignStatusEnums[]>([]);
  const [message, setMessage] = useState<ToastMessage | null>(null);
  const userInfo = EncryptionUtils.get<any>("userInfo", null);
  const userId = userInfo?.id;
  const createdBy = userInfo?.email;
  const columns = [{ key: "serialNumber", label: "S.No." }, { key: "campaignName", label: "Campaign Name" }, { key: "functionName", label: "Function Name" }, { key: "functionId", label: "Function ID" }, { key: "assignedCheckList", label: "Function Checklist Name" }, { key: "auditStatus", label: "Function Audit Status" }, { key: "actions", label: "Action" }];
  const exportableColumns = columns.filter(col => col.key !== "serialNumber" && col.key !== "actions")
  useEffect(() => {
    const permissions = EncryptionUtils.get<any>("permissions", null);
    if (permissions.tabs && permissions.tabs["funtionCheckListExecution"]) {
      setFields(permissions.tabs["funtionCheckListExecution"].fields);
    } else {
      console.log("No permissions found for 'funtionCheckListExecution' tab");
    }
  }, []);
  const fetchData = useCallback(async () => {
    setLoading(true);
    const payload = buildUserPayload();
    try {
      const requestBody = [{ field: "clientId", operator: "=", value: clientId }, ...(payload ? [payload] : [])];
      const response = await apiCall("post", `/api/campaign-functions/search?page=${currentPage - 1}&size=${itemsPerPage}`, requestBody);
      const { content = [], totalElements = 0, totalPages = 0 } = response || {};
      setData(content);
      setTotalElements(totalElements);
      setTotalPages(totalPages);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  }, [clientId, currentPage, itemsPerPage]);
  const handleExportfunctionChecklist = async (campaignId: any, functionId: any, templateName: any) => {
    try {
      const requestBody = { campaignId, auditorId: userId, functionId, createdBy };
      const response = await apiCall("post", "/api/function/audit/campaign/auditor/questions", requestBody, { page: 0, size: 2_147_483_647 });
      if (!response || !response.responses) {
        setMessage(createToastMessage("No data available to export.", "warning", 3000));
        return;
      }
      const mappedData = response.responses.map((item: any) => ({ "Question": item.questionText || "", "Function Area": item.functionAreaName || "N/A", "Evidence Required": item.evidenceRequired || "N/A", "ISO Clause Reference": item.isoClauseReference || "N/A", "Annex A Control Reference": item.annexAControlReference || "N/A", "Type of Findings": item.typeOfFindings || "", "Findings": item.findings || "", "Attachments": item.attachments ? item.attachments.map((att: any) => att.fileKey).join(", ") : "" }));
      const worksheet = XLSX.utils.json_to_sheet(mappedData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Function Audit Checklist");
      if (mappedData.length > 0) {
        const colWidths = Object.keys(mappedData[0]).map(key => ({
          wch: Math.max(
            key.length,
            ...mappedData.map((row: { [x: string]: any; }) => String(row[key] || "").length)
          )
        }));
        worksheet['!cols'] = colWidths;
      }
      const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
      const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${templateName}_Function_Audit_Checklist_${new Date().toISOString().split('T')[0]}.xlsx`;
      a.click();
      window.URL.revokeObjectURL(url);
      setMessage(createToastMessage("Function checklist exported successfully!", "success", 3000));
    } catch (error: any) {
      const errorMessage = error?.response?.data?.message || "Export failed.";
      setMessage(createToastMessage(errorMessage, "error", 3000));
    }
  };
  useEffect(() => {
    const fetchStatusEnums = async () => {
      try {
        const response = await apiCall("get", "/api/enums/CampaignStatusEnum");
        setCampaignStatusEnums(response);
      } catch (error) {
        console.error("Error fetching status enums:", error);
      }
    };
    fetchStatusEnums();
  }, []);
  const getCampaignStatusDescription = useCallback((statusValue: string) => {
    const foundStatus = campaignStatusEnums.find(enumItem => enumItem.value === statusValue);
    return foundStatus ? foundStatus.description : statusValue;
  }, [campaignStatusEnums]);
  useEffect(() => {
    const fetchFunctionEnums = async () => {
      try {
        const response = await apiCall("get", "/api/enums/FunctionEnum");
        setFunctionEnums(response || []);
      } catch (error) {
        console.error("Error fetching function enums:", error);
      }
    };
    fetchFunctionEnums();
  }, []);
  const getFunctionDescription = useCallback((value: string) => {
    const enumItem = functionEnums.find(item => item.value === value);
    return enumItem ? enumItem.description : value || "N/A";
  }, [functionEnums]);
  const fetchAllDataForExport = useCallback(async () => {
    const payload = buildUserPayload();
    try {
      const requestBody = [{ field: "clientId", operator: "=", value: clientId }, ...(payload ? [payload] : [])];
      const response = await apiCall("post", `/api/campaign-functions/search?page=0&size=${totalElements}`, requestBody);
      return response?.content?.map((item: any) => ({ campaignName: item.campaignName || "N/A", functionName: getFunctionDescription(item.functionName) || "N/A", functionId: item.functionId || "N/A", assignedCheckList: item.assignedCheckList || "N/A", auditStatus: getCampaignStatusDescription(item.auditStatus) || "N/A" })) || [];
    } catch (error) {
      console.error("Error exporting data:", error);
      return [];
    }
  }, [clientId, totalElements, getFunctionDescription, getCampaignStatusDescription]);
  useEffect(() => { fetchData(); }, [fetchData]);
  const handleDetailsPage = (campaignId: string, functionId: string) => { navigate(`/auditorfunctionchecklistdetails/${campaignId}/${functionId}`) };
  const handleViewExecuteFunctionChecklist = (row: any) => {
    navigate(`/auditorviewfuntionchecklistdetails/${row.campaignId}/${row.functionId}`);
  };
  return (
    <div className="table-details">
      <div className="table-title">
        <h2>Function Audit</h2>
        <div className="table-title-actions">
          <ExportButton data={data} columns={exportableColumns} fetchAllData={fetchAllDataForExport} fileName={`Function Audits`} />
        </div>
      </div>
      <div className="table-container">
        <div className="table-inner-container">
          <table className="main-table">
            <thead>
              <tr>
                {columns.map((column) => (
                  <th key={column.key}>{column.label}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {Array.isArray(data) && data.length === 0 ? (
                <tr>
                  <td colSpan={columns.length} className="no-data">No data available</td>
                </tr>
              ) : (
                data.map((row, index) => (
                  <tr key={row.campaignId || row.functionId || index}>
                    <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                    <td>{row.campaignName || "N/A"}</td>
                    <td>{getFunctionDescription(row.functionName || "N/A")}</td>
                    <td>{row.functionId || "N/A"}</td>
                    <td>{row.assignedCheckList || "N/A"}</td>
                    <td>{getCampaignStatusDescription(row.auditStatus || "N/A")}</td>
                    <td>
                      {fields.view && (
                        <FaEye className="action-button" onClick={() => handleViewExecuteFunctionChecklist(row)} title="View Execute" />
                      )}
                      {fields.create && row.auditStatus !== "CLOSED" && row.campaignStatus !== "NOT_STARTED" && (
                        <FaPlus className="action-button" onClick={() => handleDetailsPage(row.campaignId, row.functionId)} title="Execute Audit" />
                      )}
                      <FaFileExport className="action-button" title="Export Checklist Details" onClick={() => handleExportfunctionChecklist(row.campaignId, row.functionId, row.assignedCheckList || "Function_Checklist")} />
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
      <Pagination currentPage={currentPage} totalPages={totalPages} totalElements={totalElements} itemsPerPage={itemsPerPage} onPageChange={setCurrentPage} onItemsPerPageChange={setItemsPerPage} />
      {message && (<ToastPopup message={message.text} type={message.type} duration={message.duration} onClose={() => setMessage(null)} />)}    </div>
  );
};
export default AuditorFunctionChecklist;